import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import OutreachDashboard from "./components/outreach/OutreachDashboard";
import OutreachAdminPanel from "./components/outreach/OutreachAdminPanel";
import OutreachLogin from "./components/outreach/OutreachLogin";
import {
  getOutreachSession,
  clearOutreachSession,
} from "./lib/outreachMvpCredentials";
import "./OutreachPage.css";
import "./AdminPanel.css";

export default function OutreachPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const adminView =
    location.pathname === "/outreach/team" ? "team" : "dashboard";

  useEffect(() => {
    setSession(getOutreachSession());
    setLoading(false);
  }, []);

  useEffect(() => {
    if (session && !session.isAdmin && adminView === "team") {
      navigate("/outreach", { replace: true });
    }
  }, [session, adminView, navigate]);

  const handleLogout = () => {
    clearOutreachSession();
    setSession(null);
  };

  if (loading) {
    return (
      <div className="outreach-loading-screen">
        <div className="analytics-spinner" />
        <p>Loading…</p>
      </div>
    );
  }

  if (!session) {
    return <OutreachLogin onLoginSuccess={setSession} />;
  }

  const showTeamPanel = session.isAdmin && adminView === "team";

  return (
    <div className="outreach-page">
      <header className="outreach-page-header">
        <div>
          <h1>School Outreach</h1>
          <p className="outreach-page-sub">
            {showTeamPanel
              ? "Admin — team performance & member analytics"
              : "Claim schools · confirm last-year quiz teams · track calls & messages"}
          </p>
        </div>
        <div className="outreach-header-actions">
          <span className="outreach-user-badge">
            {session.name}
            {session.isAdmin && (
              <span className="outreach-admin-tag">Admin</span>
            )}
          </span>
          {session.isAdmin && (
            <nav className="outreach-admin-nav" aria-label="Outreach views">
              <button
                type="button"
                className={`outreach-nav-btn${
                  adminView === "dashboard" ? " active" : ""
                }`}
                onClick={() => navigate("/outreach")}
              >
                Schools
              </button>
              <button
                type="button"
                className={`outreach-nav-btn${
                  adminView === "team" ? " active" : ""
                }`}
                onClick={() => navigate("/outreach/team")}
              >
                Team stats
              </button>
            </nav>
          )}
          <a href="/admin" className="outreach-link-btn">
            Analytics
          </a>
          <button
            type="button"
            className="outreach-logout-btn"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </header>
      {showTeamPanel ? (
        <OutreachAdminPanel />
      ) : (
        <OutreachDashboard
          userEmail={session.email}
          userName={session.name}
          isAdmin={session.isAdmin}
        />
      )}
    </div>
  );
}
